import React from 'react';

const Candle2Icon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 13.125H11.25"
      stroke="#4B5563"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.75 13.125H1.5"
      stroke="#4B5563"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 4.875H14.25"
      stroke="#4B5563"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 4.875H1.5"
      stroke="#4B5563"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.25 10.875H9.75C10.575 10.875 11.25 11.25 11.25 12.375V13.875C11.25 15 10.575 15.375 9.75 15.375H5.25C4.425 15.375 3.75 15 3.75 13.875V12.375C3.75 11.25 4.425 10.875 5.25 10.875Z"
      stroke="#4B5563"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 2.625H12.75C13.575 2.625 14.25 3 14.25 4.125V5.625C14.25 6.75 13.575 7.125 12.75 7.125H8.25C7.425 7.125 6.75 6.75 6.75 5.625V4.125C6.75 3 7.425 2.625 8.25 2.625Z"
      stroke="#4B5563"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Candle2Icon;
